<template>
  <div class="app-contaioner">
    <Menu :lfArr="lfArr" :rtArr="rtArr" @handleRt="handleRt"></Menu>
    <div class="content-container">
      <RouterView />
    </div>
    <footer class="site-footer">
      <a
        class="icp-link"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ icp }}
      </a>
    </footer>
    <Modal v-model="showModal" :width="modalWidth" :height="modalHeight">
      <component :is="modalName"></component>
    </Modal>
    <ToTop />
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import Menu from "@/components/Menu";
import ToTop from "@/components/ToTop";
import Message from "@/components/Message";

export default {
  name: "App",
  components: {
    Menu,
    ToTop,
    Modal,
    Message,
  },
  data() {
    return {
      lfArr: [
        // {
        //   name: "Home",
        //   link: "",
        //   icon: "shouye",
        //   exact: true,
        //   title: "主页",
        // },
        {
          name: "Resume",
          link: "resume",
          icon: "shouye",
          exact: true,
          title: "主页",
        },
        {
          name: "Blog",
          link: "blog",
          icon: "blog",
          exact: false,
          title: "文章",
        },
        // {
        //   name: "Write",
        //   link: "write",
        //   icon: "write",
        //   exact: false,
        //   title: "写作",
        // },
        {
          name: "Project",
          link: "project",
          icon: "xiangmu",
          exact: true,
          title: "项目",
        },
      ],
      rtArr: [
        // {
        //   icon: "search",
        //   title: "搜索",
        // },
        {
          name: "Message",
          link: "message",
          icon: "liuyan",
          title: "留言",
          modalHeight: 700,
        },
      ],
      showModal: false,
      modalName: "",
      modalHeight: 400,
      modalWidth: 650,
    };
  },
  computed: {
    icp() {
      const setting =
        this.$store && this.$store.state && this.$store.state.setting;
      return (setting && setting.data && setting.data.icp) || "蜀ICP备2025144458号";
    },
  },
  methods: {
    handleRt(item) {
      this.showModal = true;
      this.modalName = item.name;
      this.modalHeight = item.modalHeight || 400;
      this.modalWidth = item.modalWidth || 650;
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
@import "~@/styles/mixin.less";
.app-contaioner {
  width: 100vw;
  height: 100vh;
  .flex-col();
}
.content-container {
  width: 100%;
  height: calc(100% - 100px - 44px);
  padding: 30px;
  margin-top: 100px;
}
.site-footer {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 12px;
  color: @gray;
}
.icp-link {
  color: inherit;
  text-decoration: none;
}
.icp-link:hover {
  text-decoration: underline;
}
</style>
